import React from "react";
import NoteInfo from "./BookModule.module.css";
import moment from "moment";

export default function PreOrderNote({ preOrderdata = [] }) {
  return (
    <div className={NoteInfo.PreOrderNoteSec}>
      <p className={NoteInfo.NoteLabel}>
        <strong>NOTE:</strong> Some books in this set are currently out of stock
        and marked as <strong>Pre-Order</strong>, which may cause a delay in
        their delivery. Estimated delivery dates for these Pre-Order books are
        provided below. To reduce waiting time, your order will be shipped in
        multiple parts: available items will be shipped first, and the delayed
        books will follow. We apologize for the inconvenience and thank you for
        your patience and understanding.
      </p>
      <div className={`mx-0`}>
        <ul className={`${NoteInfo.NoteLabellistItem} p-0`}>
          {preOrderdata.length > 0 &&
            preOrderdata?.map((item) => {
              return (
                <li>
                  <strong>{item.book_title}</strong> - Expected by
                  <strong className="ms-2">
                    {item.expected_date !== null
                      ? moment(item.expected_date).format("DD/MM/YYYY")
                      : "_"}
                  </strong>
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
}
